import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

import Swal from 'sweetalert2';

// Global Axios Interceptor for Token Expiry and Permissions
axios.interceptors.response.use(
  (response) => {
    // Check if it's a DELETE request and backend returns a 200 OK but with status: false
    // and the specific permission error
    if (
      response.config?.method === 'delete' &&
      response.data &&
      response.data.status === false &&
      response.data.error === 'You do not have permission for this action'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: response.data.error,
        confirmButtonColor: '#dc2626'
      });
      // Rejecting prevents the component's success logic from accidentally running
      return Promise.reject(new Error(response.data.error));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // If unauthorized, clear tokens and redirect to login
      if (window.location.pathname !== '/login' && !window.location.pathname.startsWith('/vendor-portal/')) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    } else if (
      error.config?.method === 'delete' &&
      error.response &&
      error.response.data &&
      error.response.data.error === 'You do not have permission for this action'
    ) {
      // If the backend returns a 403 or 400 permission error explicitly on a DELETE request
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: error.response.data.error,
        confirmButtonColor: '#dc2626'
      });
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
